module.exports = __webpack_public_path__ + "img/luoxuangan.prt.17fc630b.jpg";